// extracted by mini-css-extract-plugin
export default {"toggle":"toggle___18MQa","open":"open___2GuLl","spinnerContainer":"spinnerContainer___3SF9d"};